module.exports = __webpack_public_path__ + "58744f9dcefd21c5bd75b0bd2794581c.mp4";


//////////////////
// WEBPACK FOOTER
// ./assets/videos/WaveDesktop.mp4
// module id = 226
// module chunks = 0